
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impact-api",
      function () {
        return require("private-next-pages/impact-api.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impact-api"])
      });
    }
  